import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    const whatDamageArray: string[] = getValueOrDefault(formConfig, formValues, 'whatDamageOccurDuringFire')
        .map((e: any) => e.value)
        .sort()
        .reverse();

    switch (curPageId) {
        case 'godt-at-vide':
            return 'dato';
        case 'dato':
            return 'adresse';
        case 'adresse':
            return 'beskriv-skaden';
        case 'beskriv-skaden':
            return 'aarsag';
        case 'aarsag':
            return 'hvilke-skader';
        case 'hvilke-skader':
            if (whatDamageArray[0] === 'damagedItems') {
                return 'registrering-af-genstande';
            } else {
                return 'reparation-af-skaden';
            }
        case 'registrering-af-genstande':
            if (getValueOrDefault(formConfig, formValues, 'areYouReadyToRegister').value === 'yes') {
                return 'genstandsregistrering';
            } else {
                if (whatDamageArray[1] === 'damagedBuilding') {
                    return 'reparation-af-skaden';
                } else {
                    return 'dokumentation';
                }
            }
        case 'genstandsregistrering':
            if (whatDamageArray[1] === 'damagedBuilding') {
                return 'reparation-af-skaden';
            } else {
                return 'dokumentation';
            }
        case 'reparation-af-skaden':
            const whoRepairsDamage = getValueOrDefault(formConfig, formValues, 'whoRepairsDamage').value;
            if (whoRepairsDamage === 'other' || whoRepairsDamage === 'customer') {
                return 'pris-paa-reparation';
            } else {
                return 'dokumentation';
            }
        case 'pris-paa-reparation':
            return 'dokumentation';
        case 'dokumentation':
            return 'om-dig';
        case 'om-dig':
            return 'resume';
        default:
            throw new Error('Unknown page: ' + curPageId);
    }
};
